import { takeEvery } from 'redux-saga'
import { put, call } from 'redux-saga/effects'
import { BLANK } from 'helpers/globals'
import { GET_STREETVIEW } from 'actions/mapTypes'
import { batchUpdateCalculatorAction } from 'actions/calculatorActions'
import { notifyHoneybadgerAction } from 'actions/applicationActions'
import axios from 'axios'

const signStreetViewURL = url =>
  ENV === 'development'
  ? url
  : axios.post(`https://9qwutxzvm3.execute-api.us-east-1.amazonaws.com/dev/signurl`, { url, env: BETA ? 'beta' : ENV })
    .then(({ data }) => data.signedURL)

export function * getStreetView(action) {
  const { componentState: { status, heading, cameraMarkerPosition, tilt, id, streetViewActive, streetViewAvailable, userSelectedGeneralScene, mapType } } = action
  try {
    if (mapType !== BLANK && status === google.maps.StreetViewStatus.OK) {
      const url = `https://maps.googleapis.com/maps/api/streetview?key=AIzaSyDnaiLa-4NndCdT_Efd2HE3KQ-OdFH4noA&size=640x483&location=${cameraMarkerPosition.lat()},${cameraMarkerPosition.lng()}&heading=${heading}&fov=180&pitch=${tilt}`
      const signedURL = yield call(signStreetViewURL, url)

      // conditionally add streetViewActive and streetViewAvailable to the action to avoid triggering multiple dispatches
      yield put(batchUpdateCalculatorAction(
        Object.assign(
          { streetViewUrl: signedURL },
          (!streetViewActive) && { streetViewActive: !userSelectedGeneralScene, streetViewAvailable: true }
        ),
        ['streetViewUrl', ...!streetViewActive ? ['streetViewActive', 'streetViewAvailable'] : ''].filter(a => a !== ''),
        id,
        false
      ))
    } else if (streetViewActive || streetViewAvailable) {
      yield put(
        batchUpdateCalculatorAction({ streetViewActive: false, streetViewAvailable: false }, ['streetViewActive', 'streetViewAvailable'], id, false)
      )
    }
  } catch (err) {
    yield put(notifyHoneybadgerAction(err, action))
  }
}

export function * watchGetStreetview() {
  yield * takeEvery(GET_STREETVIEW, getStreetView)
}



// WEBPACK FOOTER //
// ./src/sagas/getStreetViewSaga.js